import { Radio } from 'antd';

const CustomRadio = ({ Form, rules, data, parentKey, renderRadio }) => {
    return (
        <Form.Item name={[parentKey, data.name]}  label={data.title} rules={rules?.[data?.name]}>
            <Radio.Group options={data.options} />
                {/* {renderRadio(data.optionKey)} */}
           {/*  </Radio.Group> */}
        </Form.Item>
    )
}

export default CustomRadio;